export default {
  sitemap: {
    title: 'Sitemap',
    sections: {
      general: 'General',
      categories: 'Categories',
      cities: 'Cities',
      cityCategories: 'Cities and categories',
      generalTransactionalPages: 'Various topics',
      events: 'Classes and workshops',
      partnerProfiles: 'Partner profiles',
      articles: 'Magazine articles',
    },
    pagesLabelTitles: {
      city: 'Classes in {title}',
      category: '{title}',
      cityCategory: '{title}',
      generalTransactionalPage: '{title}',
    },
    pathTitles: {
      '/': 'Home',
      '/contactUs/': 'Contact',
      '/faq/': 'FAQ',
      '/impressum/': 'Impressum',
      '/_nuxt3-static/partner/': 'Partner',
      'terms-and-conditions/': 'AGB',
      'terms-supplier/': 'Angebotsanbieter-AGB',
      '/teamevent/': 'Team Events',
      '/giftcard/': 'Giftcard',
      '/_nuxt3-static/partner/pricing/': 'Partner Pricings',
    },
  },
}
